import React, { useState } from 'react';
import {
  Box,
  Tabs,
  Tab,
  Paper,
  Typography,
  Alert,
} from '@mui/material';
import ContractorProfilesTab from './tabs/ContractorProfilesTab';
import HourRateManagementTab from './tabs/HourRateManagementTab';
import AccountAccessControlTab from './tabs/AccountAccessControlTab';
import ProjectAssignmentTab from './tabs/ProjectAssignmentTab';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

const ContractorManagementWidget: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);
  const [error, setError] = useState<string | null>(null);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Box>
      <Paper sx={{ mb: 2 }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}>
          <Typography variant="h5" sx={{ py: 2, fontWeight: 600 }}>
            Contractor Management
          </Typography>
          <Alert severity="info" sx={{ mb: 2 }}>
            <Typography variant="body2">
              <strong>Available Functions:</strong> Create Contractor | Edit Password | Add Project Assignment | Manage Rates | Approve Hours
            </Typography>
          </Alert>
          <Tabs value={tabValue} onChange={handleTabChange} aria-label="contractor management tabs">
            <Tab label="Contractor Profiles" />
            <Tab label="Hour & Rate Management" />
            <Tab label="Account & Access Control" />
            <Tab label="Project Assignment & Tracking" />
          </Tabs>
        </Box>
      </Paper>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      <TabPanel value={tabValue} index={0}>
        <ContractorProfilesTab />
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <HourRateManagementTab />
      </TabPanel>
      <TabPanel value={tabValue} index={2}>
        <AccountAccessControlTab />
      </TabPanel>
      <TabPanel value={tabValue} index={3}>
        <ProjectAssignmentTab />
      </TabPanel>
    </Box>
  );
};

export default ContractorManagementWidget;

